import {
  WishlistProduct,
  wishlistProductFromResponse,
} from './WishlistProduct';

export interface WishlistLine {
  product: WishlistProduct;
  productID: number;
  userID: number;
}

export const wishlistLineFromResponse = (responseData: any): WishlistLine => ({
  product: wishlistProductFromResponse(responseData.product),
  productID: responseData.product_id,
  userID: responseData.user_id,
});
